import { render } from "./VocabularyList.vue?vue&type=template&id=12e1dabf&scoped=true"
import script from "./VocabularyList.vue?vue&type=script&lang=js"
export * from "./VocabularyList.vue?vue&type=script&lang=js"

import "./VocabularyList.vue?vue&type=style&index=0&id=12e1dabf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e1dabf"]])

export default __exports__